import React, { useEffect, useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import AddCustomer from './pages/AddCustomer';
import EditCustomer from './pages/EditCustomer';
import Measurements from './pages/Measurements';
import AddMeasurement from './pages/AddMeasurement';
import EditMeasurement from './pages/EditMeasurement';
import Orders from './pages/Orders';
import AddOrder from './pages/AddOrder';
import EditOrder from './pages/EditOrder';
import Login from './pages/Login';
import AdminPanel from './pages/AdminPanel';
import { AlertProvider } from './context/AlertContext';

function App() {
  const [isBooting, setIsBooting] = useState(true);
  const [auth, setAuth] = useState(() => {
    const stored = localStorage.getItem('authState');
    return stored ? JSON.parse(stored) : { isAuthenticated: false, role: null };
  });

  useEffect(() => {
    const timer = setTimeout(() => setIsBooting(false), 900);
    return () => clearTimeout(timer);
  }, []);

  const handleLogin = useCallback((username, password) => {
    if (username === 'shahroz' && password === '123') {
      const next = { isAuthenticated: true, role: 'admin' };
      localStorage.setItem('authState', JSON.stringify(next));
      setAuth(next);
      return { success: true };
    }
    if (username === 'user' && password === '123') {
      const next = { isAuthenticated: true, role: 'user' };
      localStorage.setItem('authState', JSON.stringify(next));
      setAuth(next);
      return { success: true };
    }
    return { success: false, message: 'Invalid credentials' };
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.removeItem('authState');
    setAuth({ isAuthenticated: false, role: null });
  }, []);

  if (isBooting) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-primary-600 text-white">
        <div className="space-y-4 text-center">
          <div className="text-3xl font-semibold">Tailor Shop</div>
          <div className="flex items-center justify-center space-x-2">
            <span className="h-3 w-3 rounded-full bg-white animate-pulse" />
            <span className="h-3 w-3 rounded-full bg-white animate-pulse delay-150" />
            <span className="h-3 w-3 rounded-full bg-white animate-pulse delay-300" />
          </div>
          <p className="text-sm text-white/80">Loading your workspace...</p>
        </div>
      </div>
    );
  }

  return (
    <AlertProvider>
      <Router>
        <Routes>
          {!auth.isAuthenticated && (
            <>
              <Route path="/login" element={<Login onLogin={handleLogin} />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </>
          )}

          {auth.isAuthenticated && (
            <>
              <Route path="/login" element={<Navigate to="/" replace />} />
              <Route
                path="/*"
                element={
                  <Layout onLogout={handleLogout} role={auth.role}>
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/customers" element={<Customers />} />
                      <Route path="/customers/new" element={<AddCustomer />} />
                      <Route path="/customers/:id" element={<CustomerDetail />} />
                      <Route path="/customers/:id/edit" element={<EditCustomer />} />
                      <Route path="/measurements" element={<Measurements />} />
                      <Route path="/measurements/new" element={<AddMeasurement />} />
                      <Route path="/measurements/:id/edit" element={<EditMeasurement />} />
                      <Route path="/orders" element={<Orders />} />
                      <Route path="/orders/new" element={<AddOrder />} />
                      <Route path="/orders/:id/edit" element={<EditOrder />} />
                      {auth.role === 'admin' && <Route path="/admin" element={<AdminPanel />} />}
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                  </Layout>
                }
              />
            </>
          )}
        </Routes>
      </Router>
    </AlertProvider>
  );
}

export default App;

